import React from "react";
import { AlertTriangle, X } from "lucide-react";

interface WarningNoticeProps {
  message: string;
  tip?: string;
  className?: string;
  onDismiss?: () => void;
  dismissLabel?: string;
  dismissAriaLabel?: string;
}

const WarningNotice: React.FC<WarningNoticeProps> = ({ 
    message,
    tip,
    className = "",
    onDismiss,
    dismissLabel,
    dismissAriaLabel,
}) => {
  const ariaLabel = dismissAriaLabel || dismissLabel || "Dismiss";

  return (
    <div className={`p-3 bg-yellow-50 dark:bg-yellow-950/20 rounded-md border border-yellow-500/50 ${className}`}>
      <div className="flex items-start space-x-2">
        <AlertTriangle className="h-4 w-4 text-yellow-600 mt-0.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-yellow-600">
            {message}
          </p>
          {tip && (
            <p className="text-xs text-yellow-600/80 mt-1">
              {tip}
            </p>
          )}
        </div>
        {onDismiss && (
          dismissLabel ? (
            <button
              type="button"
              onClick={onDismiss}
              className="text-sm font-medium text-yellow-700 hover:text-yellow-900 flex-shrink-0 underline-offset-2 hover:underline"
              aria-label={ariaLabel}
            >
              {dismissLabel}
            </button>
          ) : (
            <button
              type="button"
              onClick={onDismiss}
              className="text-yellow-600 hover:text-yellow-800 flex-shrink-0 p-0.5"
              aria-label={ariaLabel}
            >
              <X className="h-4 w-4" />
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default WarningNotice;
